<template>
  <div>
    <h1>Geschwärzte Dokumente</h1>
    <p>Die Ermittler konnten bei Leonhard Wolf zwei Dokumente sicherstellen, deren Inhalt teilweise geschwärzt worden ist. Die beiden Dateien könnt ihr hier herunterladen:</p>
    <ul>
    <li><a href="/M10-SA3-05-2011.pdf">M10-SA3-05-2011.pdf</a></li>
    <li><a href="/brief.jpg">brief.jpg</a></li>
    </ul>
    <p>Die Dateien werden möglicherweise direkt im Browser geöffnet. Für die weitere Verarbeitung, etwa mit Inkscape, müsst ihr die Dateien zuerst irgendwo im Dateisystem abspeichern.</p>
  </div>
</template>

<script>
export default {
  name: 'redacted',
  components: {
  }
}
</script>
